(function () {
  'use strict';

  var STORAGE_KEY = 'ssapLeadFormValues';
  var STEP_KEY = 'ssapLeadFormStep';
  var TOTAL_STEPS = 4;
  var STEP_LABELS = { 1: 'Business', 2: 'Your Books', 3: 'Services', 4: 'Contact' };

  var wrap = document.querySelector('[data-ssap-lead-form-wrap]');
  if (!wrap) return;

  function clearValues() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
      sessionStorage.removeItem(STEP_KEY);
    } catch (e) { /* ignore */ }
  }

  // If the server-rendered state confirms a successful submission, the draft
  // is no longer needed. Clear it here regardless of whether the qualification
  // form markup is present on this load.
  if (wrap.querySelector('[data-ssap-success]')) {
    clearValues();
  }

  var form = wrap.querySelector('[data-ssap-lead-form]');
  if (!form) return; // success or blocked state rendered instead

  var steps = Array.prototype.slice.call(form.querySelectorAll('[data-ssap-step]'));
  var backBtn = form.querySelector('[data-ssap-back]');
  var nextBtn = form.querySelector('[data-ssap-next]');
  var submitBtn = form.querySelector('[data-ssap-submit]');
  var submitNote = form.querySelector('[data-ssap-submit-note]');
  var progressText = form.querySelector('[data-ssap-progress-text]');
  var progressFill = form.querySelector('[data-ssap-progress-fill]');

  var currentStep = 1;

  function qsAll(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function getQueryParam(name) {
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get(name) || '';
    } catch (e) {
      return '';
    }
  }

  // ---------- Attribution / hidden fields ----------
  function setHidden(id, value) {
    var el = document.getElementById(id);
    if (el) el.value = value || '';
  }

  setHidden('SSAPSourcePage', window.location.pathname + window.location.search);
  setHidden('SSAPUtmSource', getQueryParam('utm_source'));
  setHidden('SSAPUtmMedium', getQueryParam('utm_medium'));
  setHidden('SSAPUtmCampaign', getQueryParam('utm_campaign'));

  var requestedService = getQueryParam('service');
  if (requestedService) {
    setHidden('SSAPRequestedService', requestedService);
    var serviceMap = {
      'monthly-bookkeeping': ['Monthly Bookkeeping'],
      'cleanup': ['Bookkeeping Cleanup / Catch-Up'],
      'contractors': ['Contractor & Construction Bookkeeping'],
      'payroll': ['Payroll Support'],
      'business-tax': ['Business Tax Preparation', 'Tax Planning']
    };
    var mappedValues = serviceMap[requestedService];
    if (mappedValues) {
      mappedValues.forEach(function (val) {
        var cb = form.querySelector('[data-ssap-service][value="' + val + '"]');
        if (cb) cb.checked = true;
      });
    }
  }

  // ---------- Name field mapping (contact[name] = First + Last) ----------
  // Kept in sync continuously (not only on the JS 'submit' event) because
  // some submission paths (e.g. an anti-spam widget calling form.submit()
  // programmatically) do not dispatch the 'submit' event that
  // addEventListener listens for, per the DOM spec. Updating on every
  // keystroke and on init guarantees the hidden field is already correct
  // well before any submission attempt occurs.
  function updateHiddenName() {
    var first = document.getElementById('SSAP-first-name');
    var last = document.getElementById('SSAP-last-name');
    var firstVal = first ? first.value.trim() : '';
    var lastVal = last ? last.value.trim() : '';
    var combined = (firstVal + ' ' + lastVal).trim();
    setHidden('SSAPHiddenName', combined);
  }

  ['SSAP-first-name', 'SSAP-last-name'].forEach(function (id) {
    var el = document.getElementById(id);
    if (el) el.addEventListener('input', updateHiddenName);
  });

  // ---------- Persistence (sessionStorage) ----------
  function collectValues() {
    var data = {};
    qsAll('input, select, textarea', form).forEach(function (el) {
      if (!el.id && !el.name) return;
      var key = el.id || el.name;
      if (el.type === 'checkbox' || el.type === 'radio') {
        if (el.type === 'radio') {
          if (el.checked) data[el.name] = el.value;
        } else {
          data[key] = el.checked;
        }
      } else {
        data[key] = el.value;
      }
    });
    return data;
  }

  function saveValues() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(collectValues()));
      sessionStorage.setItem(STEP_KEY, String(currentStep));
    } catch (e) { /* ignore storage errors */ }
  }

  function restoreValues() {
    var raw;
    try {
      raw = sessionStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return;
    }
    if (!raw) return;
    var data;
    try {
      data = JSON.parse(raw);
    } catch (e) {
      return;
    }
    qsAll('input, select, textarea', form).forEach(function (el) {
      if (el.type === 'radio') {
        if (data[el.name] === el.value) el.checked = true;
        return;
      }
      var key = el.id || el.name;
      if (!(key in data)) return;
      if (el.type === 'checkbox') {
        el.checked = !!data[key];
      } else {
        el.value = data[key];
      }
    });
    syncConditionalReveals();
    syncServicesHiddenField();
  }

  // ---------- Conditional reveal ----------
  function syncConditionalReveals() {
    qsAll('[data-ssap-reveal-trigger]', form).forEach(function (trigger) {
      var revealValue = trigger.getAttribute('data-ssap-reveal-value');
      var targetId = trigger.getAttribute('data-ssap-reveal-target');
      var target = document.getElementById(targetId);
      if (!target) return;

      var currentValue = '';
      if (trigger.tagName === 'SELECT') {
        currentValue = trigger.value;
      } else {
        // radio fieldset: find checked radio inside
        var checked = trigger.querySelector('input[type="radio"]:checked');
        currentValue = checked ? checked.value : '';
      }

      var shouldShow = currentValue === revealValue;
      target.hidden = !shouldShow;

      if (!shouldShow) {
        // clear stale values so they don't submit
        qsAll('input, select, textarea', target).forEach(function (el) {
          if (el.type === 'checkbox' || el.type === 'radio') {
            el.checked = false;
          } else {
            el.value = '';
          }
        });
      }
    });
  }

  form.addEventListener('change', function (e) {
    if (e.target.closest('[data-ssap-reveal-trigger]') || e.target.matches('[data-ssap-reveal-trigger]')) {
      syncConditionalReveals();
    }
    if (e.target.hasAttribute('data-ssap-service')) {
      syncServicesHiddenField();
    }
    saveValues();
  });

  // ---------- Services checkboxes -> single hidden field ----------
  function syncServicesHiddenField() {
    var selected = qsAll('[data-ssap-service]', form)
      .filter(function (cb) { return cb.checked; })
      .map(function (cb) { return cb.value; });
    setHidden('SSAPServicesNeeded', selected.join(', '));
  }

  // ---------- Validation ----------
  function showFieldError(field, message) {
    var container = field.closest('.ssap-lead-form__field') || field.closest('.ssap-lead-form__radio-fieldset') || field.closest('.ssap-lead-form__acknowledgment');
    if (!container) return;
    var errorEl = container.querySelector('[data-ssap-field-error]');
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.classList.add('is-visible');
    }
    field.setAttribute('aria-invalid', 'true');
  }

  function clearFieldError(field) {
    var container = field.closest('.ssap-lead-form__field') || field.closest('.ssap-lead-form__radio-fieldset') || field.closest('.ssap-lead-form__acknowledgment');
    if (!container) return;
    var errorEl = container.querySelector('[data-ssap-field-error]');
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.classList.remove('is-visible');
    }
    field.removeAttribute('aria-invalid');
  }

  function validateStep(stepEl) {
    var valid = true;
    var firstInvalid = null;

    // Standard required inputs/selects/textareas
    qsAll('input[required], select[required], textarea[required]', stepEl).forEach(function (field) {
      if (field.type === 'radio') return; // handled via fieldset below
      if (field.hidden || field.closest('[hidden]')) return;
      if (!field.value || (field.type === 'checkbox' && !field.checked)) {
        valid = false;
        showFieldError(field, 'This field is required.');
        if (!firstInvalid) firstInvalid = field;
      } else if (field.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.value)) {
        valid = false;
        showFieldError(field, 'Please enter a valid email address.');
        if (!firstInvalid) firstInvalid = field;
      } else {
        clearFieldError(field);
      }
    });

    // Required radio groups (a radio with [required] anywhere in the group)
    var radioGroupsSeen = {};
    qsAll('input[type="radio"][required]', stepEl).forEach(function (radio) {
      if (radio.hidden || radio.closest('[hidden]')) return;
      if (radioGroupsSeen[radio.name]) return;
      radioGroupsSeen[radio.name] = true;
      var groupChecked = stepEl.querySelector('input[type="radio"][name="' + radio.name + '"]:checked');
      var fieldset = radio.closest('fieldset');
      if (!groupChecked) {
        valid = false;
        showFieldError(radio, 'Please select an option.');
        if (!firstInvalid) firstInvalid = radio;
      } else if (fieldset) {
        clearFieldError(radio);
      }
    });

    if (firstInvalid) {
      firstInvalid.focus();
    }

    return valid;
  }

  // ---------- Step navigation ----------
  function updateProgress() {
    if (progressText) {
      progressText.textContent = 'Step ' + currentStep + ' of ' + TOTAL_STEPS + ' \u2014 ' + STEP_LABELS[currentStep];
    }
    if (progressFill) {
      progressFill.style.width = (currentStep / TOTAL_STEPS * 100) + '%';
    }
  }

  function showStep(stepNumber) {
    steps.forEach(function (stepEl) {
      var isCurrent = parseInt(stepEl.getAttribute('data-ssap-step'), 10) === stepNumber;
      stepEl.hidden = !isCurrent;
      stepEl.setAttribute('aria-hidden', isCurrent ? 'false' : 'true');
    });

    backBtn.hidden = stepNumber === 1;
    nextBtn.hidden = stepNumber === TOTAL_STEPS;
    submitBtn.hidden = stepNumber !== TOTAL_STEPS;
    if (submitNote) submitNote.hidden = stepNumber !== TOTAL_STEPS;

    currentStep = stepNumber;
    updateProgress();
    saveValues();

    var heading = steps[stepNumber - 1] && steps[stepNumber - 1].querySelector('.ssap-lead-form__step-heading');
    if (heading) heading.setAttribute('tabindex', '-1');
    if (heading) heading.focus();
  }

  nextBtn.addEventListener('click', function () {
    var stepEl = steps[currentStep - 1];
    if (!validateStep(stepEl)) return;
    if (currentStep < TOTAL_STEPS) {
      showStep(currentStep + 1);
    }
  });

  backBtn.addEventListener('click', function () {
    if (currentStep > 1) {
      showStep(currentStep - 1);
    }
  });

  form.addEventListener('submit', function (e) {
    var stepEl = steps[currentStep - 1];
    if (!validateStep(stepEl)) {
      e.preventDefault();
      return;
    }

    // Redundant safety-net update in case something changed the name
    // fields without firing an 'input' event.
    updateHiddenName();

    syncServicesHiddenField();

    // Save the draft immediately before the browser navigates away for
    // submission. The draft is intentionally NOT cleared here: it must
    // survive a Shopify-side validation error. It is only cleared once
    // the server-rendered response confirms form.posted_successfully?
    // (see the success check near the top of this file).
    saveValues();
  });

  // ---------- Init ----------
  restoreValues();
  updateHiddenName();
  syncConditionalReveals();
  syncServicesHiddenField();

  var savedStep = 1;
  try {
    var raw = sessionStorage.getItem(STEP_KEY);
    if (raw) savedStep = Math.min(Math.max(parseInt(raw, 10) || 1, 1), TOTAL_STEPS);
  } catch (e) { /* ignore */ }

  showStep(savedStep);
})();
